<agr-dialog [data]="data" [verticalSpacing]="true" (cancel)="cancel()" class="drill-cow-list">
  <div class="flex--justify-space-between">
    <mat-slide-toggle
      [hideIcon]="true"
      (change)="showAllCowsChange($event)"
      [(ngModel)]="showAllCows"
      color="primary"
    >
      {{ 'shared.drill-cow-list.show-all-cows' | translate }}
    </mat-slide-toggle>
  </div>
  <div class="flex--justify-space-between">
    <div class="flex__child--auto spacing--padding--all">
      @if (hasData()) {
        <div class="table-desktop">
          <table
            mat-table
            #table
            [dataSource]="dataSource"
            class="table-desktop__table--alternate-rows cust-table"
          >
            @for (column of columnIds(); track column; let colIndex = $index) {
              <ng-container matColumnDef="{{ column }}">
                <th mat-header-cell *matHeaderCellDef>
                  <div>
                    {{ columns[colIndex].label | translate }}
                  </div>
                </th>
                <td mat-cell *matCellDef="let row">
                  @if (columns[colIndex].type === 'link') {
                    <div>
                      <button
                        mat-button
                        (click)="openCowDetails(row[column])"
                        [class]="{
                          selected: row[column] === internationalCowId,
                        }"
                      >
                        <span>{{ row[column] }}</span>
                        @if (row['emphasize']) {
                          <span>*</span>
                        }
                      </button>
                    </div>
                  }
                </td>
              </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="columnIds()"></tr>
            <tr mat-row *matRowDef="let row; columns: columnIds()"></tr>
          </table>
        </div>
      }
      <agr-notification-empty
        [isEmpty]="!hasData()"
        [emptyTitle]="'no_items' | translate"
        emptyImage="/assets/images/no-items.png"
        class="complete__notification-empty"
      >
      </agr-notification-empty>
    </div>
    <div class="flex--justify-space-between">
      <app-cow-details [internationalCowId]="internationalCowId"></app-cow-details>
    </div>
  </div>
</agr-dialog>
